<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jxOabZ/tc-custom/9781682302880.jpg?1726519168451" alt="This image is the cover for the book Pleasure of the Rose, The MacNeil Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pleasure of the Rose, The MacNeil Legacy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>When a Texas rogue becomes the laird of a Scottish castle, he discovers new passions in the old world in this sweeping and sexy historical romance.</b></p> Half Comanche, half Scottish, and all Texan, Fletcher MacNeil receives a surprising piece of news while sitting in jail. As the only surviving heir to the earldom of Kintyre, he has just inherited the title, a castle, and a fortune beyond his wildest dreams. But to claim it, he must travel to a world of loyal clans and kinsmen where his very appearance marks him as outsider.<br/><br/> When Rosalyn Geddes, housekeeper of Sheiling first sees Fletcher, she cannot believe the mysterious, darkly handsome man is a MacNeil, let alone the new earl. She’s even more shocked when he proposes to marry her out of necessity—for his inheritance comes with a catch.<br/><br/> If Fletcher does not produce an heir within a year, his fortune goes to a rogue cousin of the late earl. For Roz, what begins as a ploy soon blossoms into the possibility of love. But will Fletcher be done with her once he’s met the terms of the will—or will their love be the greatest fortune of all?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Bonander
      </h2>
      
      <p class="authorDescription body article">Bestselling author Jane Bonander has published over a dozen full length novels and four anthologies, all dealing with the perils and passions of romantic historical fiction. She currently lives in St. Paul, Minnesota with her husband.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25c86e56